import script from "./CRM01_008INS.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM01_008INS.vue?vue&type=script&setup=true&lang=js"

import "./CRM01_008INS.vue?vue&type=style&index=0&id=1b43a181&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b43a181"]])

export default __exports__